/**
 * Constants for external link navigation
 */

/**
 * Number of months to look back for Event History reports
 */
export const EVENT_HISTORY_MONTHS_BACK = 5;

const RIVER_BASE_URL = "https://river.amazon.com";
const TEST_SITE_CODES = ["AmazonTest", "Amazon"];

/**
 * Builds the River help URL for a given site code.
 * For test sites, returns the base River URL.
 * For real sites, returns a River URL scoped to the site's YMS help page.
 */
export const getRiverUrl = (siteCode: string): string => {
  if (!siteCode || TEST_SITE_CODES.includes(siteCode)) {
    return RIVER_BASE_URL;
  }
  return `${RIVER_BASE_URL}/${siteCode}/home/?q0=Yard%20Process&q1=Yard%20Management%20System%20(YMS)`;
};
